import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MiniBannerListWidget } from '../../../core/models';
import { MiniBannerWidgetComponent } from '../mini-banner-widget/mini-banner-widget.component';
import { NgClass } from '@angular/common';
import { Store } from '@ngrx/store';
import { userFeature } from '@src/state';
import { isWidgetVisible } from '@core/helpers';

@Component({
  selector: 'sc-mini-banner-list-widget',
  imports: [MiniBannerWidgetComponent, NgClass],
  templateUrl: './mini-banner-list-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiniBannerListWidgetComponent {
  public data = input<MiniBannerListWidget>(null);

  private readonly store = inject(Store);

  public isB2B = this.store.selectSignal(userFeature.selectIsB2B);
  public activeProduct = this.store.selectSignal(userFeature.selectActiveProduct);

  public readonly visibleWidgets = computed(() => {
    const isB2B = this.isB2B();
    const activeProduct = this.activeProduct();
    const bannerList = this.data()?.bannerList ?? [];

    return bannerList.filter((banner) => isWidgetVisible(banner, activeProduct, isB2B));
  });
}
